<button
  mat-icon-button
  color="primary"
  [matTooltip]="(expanded ? 'workspace.close' : 'workspace.open') | translate"
  (click)="onToggleClick()"
>
  <mat-icon [style.transform]="expanded ? 'rotate(180deg)' : null">
    open_in_new
  </mat-icon>
</button>
